import { render } from "./create.vue?vue&type=template&id=6696118e"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/price_bundles/create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6696118e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6696118e', __exports__)) {
    console.log('reload')
    api.reload('6696118e', __exports__)
  }
  
  module.hot.accept("./create.vue?vue&type=template&id=6696118e", () => {
    console.log('re-render')
    api.rerender('6696118e', render)
  })

}


export default __exports__